export default {
    routerName: '历史文章管理',
    article: {
        title: '标题',
        body: '详细',
        author: '作者',
        releaseTime: '公开时间',
        createStartTime: '公开开始',
        createEndTime: '公开结束',
        disabled: '禁用',
        yes: '是',
        no: '否',
        status: '状态',
        statusOption0: '草稿',
        statusOption1: '審査拒绝',
        statusOption2: '審査中',
        statusOption9: '审核通过',
        charge: '有无料',
        charge0: '有料',
        charge1: '无料',
        hits: '浏览量',
    },
    table: {
        id: 'ID',
        title: '标题',
        author: '作者',
        status: '状态',
        disabled: '禁用',
        createBy: '创建者',
        releaseTime: '公开时间',
        charge: '有无料',
        charge0: '有料',
        charge1: '无料',
        hits: '浏览量',
    },
};
